import React from 'react'
import { BrowserRouter } from 'react-router-dom'

import { AuthProvider, Authenticated } from './infra/auth'
import { ApolloProvider } from './infra/apollo'
import { PermissionCheck } from './infra/permissions'

import ErrorBoundary from './containers/ErrorBoundary'
import Routes from './containers/Routes'

import './App.css'
import Layout from './presentation/Layout'

const App = () => (
  <AuthProvider>
    <ApolloProvider>
      <BrowserRouter>
        <Layout>
          <ErrorBoundary>
            <Authenticated>
              <PermissionCheck>
                <Routes />
              </PermissionCheck>
            </Authenticated>
          </ErrorBoundary>
        </Layout>
      </BrowserRouter>
    </ApolloProvider>
  </AuthProvider>
)

export default App
